import {Object3D} from '@wonderlandengine/api';
import {DefaultSpawner} from './default-spawner.js';
import {Puzzle} from './puzzle.js';
import {BoardColor} from './board-object.js';

export class ModeAwareSpawner extends DefaultSpawner {
    static TypeName = 'mode-aware-spawner';
    static InheritProperties = true;

    protected override spawnNext(): Object3D {
        let obj = super.spawnNext();
        obj = Puzzle.instance.rules.fruitPreSpawn(obj);
        return obj;
    }

    protected override allowedToSpawn(
        objectToSpawn: [BoardColor, string]
    ): [BoardColor, string] {
        const color = Puzzle.instance.rules.preferColor(objectToSpawn[0]);
        if (color != undefined) {
            // check for undefined because preferColor can be 0
            return [color, this.objectsToSpawn.get(color)];
        }
        return objectToSpawn;
    }
}
